<app-layout preset="data">
  <app-layout-title>{{ 'SIDENAV.ROOT.webhooks' | translate }}</app-layout-title>

  <app-layout-actions>
    <a routerLink="create"
       color="primary"
       mat-stroked-button>
      <mat-icon mat-list-icon class="plus-icon">add</mat-icon>
      <mat-label>{{ 'ADMIN.add_webhook' | translate }}</mat-label>
    </a>
  </app-layout-actions>

  <app-layout-content>
    <app-table [columns]="columns"
               [dataSource]="dataSource"
               loadingType="all">

      <ng-container *app-table-header="'url'">{{ 'ADMIN.url' | translate }}</ng-container>
      <ng-container *app-table-header="'event'">{{ 'WEBHOOKS.event' | translate }}</ng-container>
      <ng-container *app-table-header="'retries'">{{ 'WEBHOOKS.retries' | translate }}</ng-container>
      <ng-container *app-table-header="'actions'">{{ 'WEBHOOKS.actions' | translate }}</ng-container>

      <ng-container *app-table-column="let webhook, name: 'url'">
        <input (click)="copyUrl($event)"
               [value]="webhook.url"
               class="url-copy"
               [matTooltip]="webhook.url"
               matTooltipClass="url-tooltip"
               readonly>
      </ng-container>

      <ng-container *app-table-column="let webhook, name: 'event'">
        <mat-chip-listbox>
          <mat-chip-option [selectable]="false"
                    [matTooltip]="(webhook.isActivated ? 'ADMIN.webhook_active' : 'ADMIN.webhook_inactive') | translate"
                    [class.secondary]="webhook.isActivated">
            {{ getEventName(webhook.event) }}
          </mat-chip-option>
        </mat-chip-listbox>
      </ng-container>

      <ng-container *app-table-column="let webhook, name: 'retries'">
        {{ webhook.retries.join(', ') }}
      </ng-container>

      <ng-container *app-table-column="let webhook, name: 'actions'">
        <a [routerLink]="['testing', webhook.id]" mat-icon-button [matTooltip]="'ADMIN.test' | translate">
          <mat-icon color="primary">insert_link</mat-icon>
        </a>
        <a [routerLink]="['update', webhook.id]" mat-icon-button [matTooltip]="'COMMON.edit' | translate">
          <mat-icon color="primary">edit</mat-icon>
        </a>
        <button (click)="removeWebhook(webhook.id)" mat-icon-button [matTooltip]="'QUERY_BUILDER.delete' | translate">
          <mat-icon color="warn">delete</mat-icon>
        </button>
      </ng-container>

    </app-table>
  </app-layout-content>
</app-layout>
